(function () {
    "use strict";

    var OrganizationEditorDialog = $app.defineClass(
        "SolovisGateway.Admin.Organizations.OrganizationEditorDialog",
        null,
        function (options) {
            var self = this;

            var desiredWidth = Math.min($(window).width() * .8, 750);
            var desiredHeight = Math.min($(window).height() * .8, 750);

            var minWidth = 100;
            var minHeight = 100;

            this._saveCallback = options.saveCallback ? options.saveCallback : null;
            this._organizationId = options.organizationId ? options.organizationId : null;
            this._isHidingUI = options.isHidingUI ? true : false;
            this._hideMfaAndPasswordPolicyFields = options.hideMfaAndPasswordPolicyFields ? true : false;
            var editorDiv = $("<div>")
                .css("min-height", "75px");

            this._organizationEditor = new SolovisGateway.Admin.Organizations.OrganizationEditorControl({
                controlHost: editorDiv,
                organizationId: this._organizationId,
                isHidingUI: this._isHidingUI,
                hideMfaAndPasswordPolicyFields: this._hideMfaAndPasswordPolicyFields
            });

            this._organizationEditor.setAsCurrentControl();

            this._dialogWindow = new Solovis.UI.Dialog({
                container: editorDiv,

                title: this._organizationId ? "Edit Organization" : "Add Organization",

                modal: true,
                center: true,
                actions: ["Close"],
                autoOpen: true,
                destroyOnClose: true,
                width: desiredWidth,
                minWidth: minWidth,
                minHeight: minHeight,
                height: desiredHeight,
                buttons: [
                    {
                        label: "Save",
                        click: function () {
                            self._save();
                        }
                    },
                    {
                        label: "Cancel",
                        click: function () {
                            self._dialogWindow.close();
                        }
                    }
                ]
            });
        }
    );

    OrganizationEditorDialog.prototype._cancel = function () {
        this._dialogWindow.close();
    };

    OrganizationEditorDialog.prototype._save = function () {
        var self = this;

        if (this._organizationEditor.isValid()) {

            var model = this._organizationEditor._getOrganizationModel();
            $app.Rpc.invokeAndWait("~/Admin/OrganizationAdmin/SetOrganization",
                {
                    model: model
                },
                function (response, success) {
                    if (success) {
                        if (response.result.modelIsValid) {
                            var savedOrganizationEditorModel = response.result.modelResult;

                            // Only show notification when adding a new environment pool.
                            var showNotification = self._organizationId ? false : true;
                            self._organizationEditor._savedOrganizationEditorModel = savedOrganizationEditorModel;

                            if (showNotification) {
                                self._organizationEditor.notify({
                                    success: true
                                });

                                var saveButton = self._dialogWindow.getButtonByLabel("Save");
                                if (saveButton) {
                                    saveButton
                                        .text("OK")
                                        .unbind("click")
                                        .click(function() {
                                            self._dialogWindow.close();
                                            if (self._saveCallback) {
                                                self._saveCallback(savedOrganizationEditorModel);
                                            }
                                        });
                                }

                                var cancelButton = self._dialogWindow.getButtonByLabel("Cancel");
                                if (cancelButton) {
                                    cancelButton.remove();
                                }
                            }
                            else {
                                self._dialogWindow.close();
                                if (self._saveCallback) {
                                    self._saveCallback(savedOrganizationEditorModel);
                                }
                            }

                        }
                        else {
                            self._organizationEditor._formBuilder.applyErrors(response.result.errors);
                        }
                    }
                });
        }
    };

    OrganizationEditorDialog.showDialog = function (options) {
        var dialog = new SolovisGateway.Admin.Organizations.OrganizationEditorDialog(options);
    }

})();